@if (showCalendar) {
	<div
		class="calendar-popup"
		[style.left.px]="xPositon === 'left' ? 0 : null"
		[style.right.px]="xPositon === 'right' ? 0 : null"
		[style.top.px]="yPosition === 'top' ? '100%' : null"
		[style.bottom.px]="yPosition === 'bottom' ? '-100%' : null"
		#calendarPopup>
		<div class="date-time-container">
			<div class="date-inputs">
				<label>{{ labels.lbl_geral_data_inicial }}</label>
				<input type="date" [value]="startDateFormatted" [max]="maxStartDateFormatted" (change)="onStartDateChange($event)" />

				<label>{{ labels.lbl_geral_data_final }}</label>
				<input type="date" [value]="endDateFormatted" [min]="minEndDateFormatted" (change)="onEndDateChange($event)" />
			</div>
			@if (showTime) {
				<div class="date-inputs">
					<label>{{ labels.lbl_hora_inicial }}:</label>
					<input type="time" [value]="startTimeFormatted" (change)="onStartTimeChange($event)" />

					<label>{{ labels.lbl_hora_final }}:</label>
					<input type="time" [value]="endTimeFormatted" (change)="onEndTimeChange($event)" />
				</div>
			}
		</div>

		<div class="calendar-container">
			<div class="calendar">
				<div class="calendar-header">
					<button (click)="changeMonth(-1)"><<</button>
					<span>{{ startMonthYear }}</span>
					<button (click)="changeMonth(1)">>></button>
				</div>
				<div class="calendar-grid">
					<div class="week-days-container">
						@for (weekday of daysOfWeek; track $index) {
							<span class="week-day">{{ weekday }}</span>
						}
					</div>
					<div class="days-container" (mouseleave)="hoveredDate = null">
						@for (viewCurrentDay of viewCurrentMonthDays; track $index) {
							<span
								class="day"
								[class.hoverable]="!startDate || !endDate"
								[class.startDate]="
									startDate && areSameDate(getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear), startDate)
								"
								[class.linkDate]="
									(startDate &&
										endDate &&
										getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear) > startDate &&
										getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear) < endDate) ||
									(hoveredDate &&
										startDate &&
										!endDate &&
										getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear) > startDate &&
										getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear) < hoveredDate) ||
									(hoveredDate &&
										!startDate &&
										endDate &&
										getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear) > hoveredDate &&
										getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear) < endDate)
								"
								[class.endDate]="
									endDate && areSameDate(getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear), endDate)
								"
								[class.disabled]="
									!viewCurrentDay ||
									(limitDateToday && isDateAfterToday(getDate(viewCurrentDay, viewCurrentMonth, viewCurrentYear)))
								"
								(mouseenter)="handleHover(viewCurrentDay, viewCurrentMonth, viewCurrentYear)"
								(click)="selectDate(viewCurrentDay)">
								{{ viewCurrentDay || '' }}
							</span>
						}
					</div>
				</div>
			</div>
		</div>
		<div class="button-container">
			<button class="cancel-btn" (click)="cancelAndClose()">{{ labels.lbl_geral_cancelar }}</button>
			<button class="confirm-btn" (click)="confirmDates()" [disabled]="isConfirmDisabled()">{{ labels.lbl_geral_confirmar }}</button>
		</div>
	</div>
}
